export const getChannelIdFromName = (name: string): string => {
    const selectedChannel = Nut.managedCollections.Channels.findWhere({name});

    return selectedChannel ? selectedChannel.id : '-';
};
